import React, { Component } from 'react';
import { Table, Alert } from 'react-bootstrap';
import { reactLocalStorage } from 'reactjs-localstorage';
import Constants from '../../../util/Constants';
import IndividualSalesReportAPI from '../../../api/IndividualSalesReportAPI';
import ChartComponent from '../FixedReportChart';
import ApiUiController from '../../../controller/ApiUiController';

class InvidualCallTalkTimeReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      totalTalkTime: 0,
      alert: null,
    };

    // Load users from local storage
    this.users = reactLocalStorage.getObject(Constants.Model)?.user?.options || [];
  }

  componentDidMount() {
    this.fetchCallTalkTime();
  }

  // Fetch call data from API
  fetchCallTalkTime = () => {
    IndividualSalesReportAPI.getIndividualCallTalktime(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  };

  handleReceivedData = (response) => {
    if (Array.isArray(response)) {
      const totalTalkTime = response.reduce((sum, item) => sum + item.sum, 0);
      this.setState({ data: response, totalTalkTime });
    }
  };

  handleFail = (error) => {
    this.setState({
      alert: 'Failed to fetch Call Talk Time data.',
    });
    console.error('Error:', error);
  };

  formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m ${remainingSeconds}s`;
  };

  formatTimeForChart = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}.${remainingSeconds}`;
  };

  getUserData = () => {
    const { data } = this.state;
    const mappedData = {};

    // Map talk time to user IDs for quick lookup
    data.forEach(({ responsible_person, sum }) => {
      mappedData[responsible_person] = sum;
    });

    return this.props.filters.selectedIds.map((id) => {
      const user = this.users.find((user) => user.value === parseInt(id));
      return {
        id,
        name: user?.name || 'Unknown',
        time: mappedData[id] || 0,
      };
    });
  };

  render() {
    const userData = this.getUserData();
    const user = userData[0].name;
    const userTime = this.formatTimeForChart(userData[0].time);
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <div className="call-talktime-report">
          <h4>Call Talktime Report</h4>
          <hr />
          <div className='row mt-3 p-2'>
            <Table bordered hover className="col-md-5">
              <thead>
                <tr>
                  <th>Sales Executive</th>
                  <th>Total Talktime</th>
                </tr>
              </thead>
              <tbody>
                {userData.map((user) => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{this.formatTime(user.time)}</td>
                  </tr>
                ))}
                <tr>
                  <td><strong>Total</strong></td>
                  <td><strong>{this.formatTime(this.state.totalTalkTime)}</strong></td>
                </tr>
              </tbody>
            </Table>
            <div className="col-md-5">
              {/* Pass only progressSums and progressOptions to ChartComponent */}
              <ChartComponent DirectSum={userTime} DirectUser={user} type={"bar"} />
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}

export default InvidualCallTalkTimeReport;
